import {API_URL_STORE} from "./urls";
import {idGenerator} from "@/services/idGenerator";

// POST requests

const addAddressApi = (address) => {
  const addressData = {
    deliveryPointCode: idGenerator(),
    deliveryPointRegionCode: address.region.domesticRegionCode,
    deliveryPointAddress: address.address,
    deliveryPointName: address.name,
    deliveryPointCity: address.city,
    deliveryPointCountryIso: address.country.countryIso,
    deliveryPointIndex: address.index,
    deliveryPointBase: address.isMain,
  };

  return window.axios
    .post(API_URL_STORE + "delivery/point/v1/createOrUpdate", {
      entityInfo: {
        ...addressData,
      },
    })
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity.deliveryPointCode;
      }

      throw new Error(data.message);
    })
    .catch((error) => {
      throw error;
    });
};

const updateAddressApi = (address, isMain) => {
  const addressData = {
    deliveryPointCode: address.code,
    deliveryPointRegionCode: address.region.domesticRegionCode,
    deliveryPointAddress: address.address,
    deliveryPointName: address.name,
    deliveryPointCity: address.city,
    deliveryPointCountryIso: address.country.countryIso,
    deliveryPointIndex: address.index,
    deliveryPointBase: isMain,
  };

  return window.axios
    .post(API_URL_STORE + "delivery/point/v1/createOrUpdate", {
      entityInfo: {
        ...addressData,
      },
    })
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity;
      }

      throw new Error(data.message);
    })
    .catch((error) => {
      throw error;
    });
};

const updateAddressStatusApi = (code, status) => {
  return window.axios
    .post(API_URL_STORE + "delivery/point/status/v1/update", {
      entityInfo: {
        deliveryPointCode: code,
        deliveryPointStatus: status,
      },
    })
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity;
      }

      throw new Error(data.message);
    })
    .catch((error) => {
      throw error;
    });
};

// GET request

const getAddressListApi = () => {
  return window.axios

    .get(API_URL_STORE + "delivery/point/v1/get")

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const addressList = data.createdEntity.deliveryPointsList.map(
          (point) => {
            return {
              code: point.deliveryPointCode,
              region: {
                regionName: point.deliveryPointRegion.regionName,
                domesticRegionCode: point.deliveryPointRegion.regionCode,
                fullName: `${point.deliveryPointRegion.regionName}, ${point.deliveryPointRegion.regionCode}`,
              },
              address: point.deliveryPointAddress,
              name: point.deliveryPointName,
              city: point.deliveryPointCity,
              country: {
                countryName: point.deliveryPointCountry.countryName,
                countryIso: point.deliveryPointCountry.countryIso,
                fullName: `${point.deliveryPointCountry.countryName}, ${point.deliveryPointCountry.countryIso}`,
              },
              index: point.deliveryPointIndex,
              isMain: point.deliveryPointBase,
            };
          }
        );

        return addressList;
      }

      throw new Error(data.message);
    })

    .catch((error) => {
      throw error;
    });
};

export {
  addAddressApi,
  updateAddressApi,
  updateAddressStatusApi,
  getAddressListApi,
};
